import {
  RESET_SALTUSOWNERS_REQUESTED,
  RESET_SALTUSOWNERS_COMPLETED,
} from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_SALTUSOWNERS_REQUESTED,
  });

  dispatch({
    type: RESET_SALTUSOWNERS_COMPLETED,
  });
};

export default resetAction;
